module.exports = __webpack_public_path__ + "static/team-4-a997294e8e0e4aec1aedb06bb1914079.png";